module.exports = __webpack_public_path__ + "img/badge_example.ccf2caef.png";